import {
    updateSharingLinkFromSharingDialog,
    updateSharingLinkUrl,
} from '../actions/internalActions';
import getSharingLinkInfo from '../selectors/getSharingLinkInfo';
import SharingLinkInfo from '../store/schema/SharingLinkInfo';
import { getSharingLinkSpecialParamsFromUrl } from '../utils/getSharingLinkSpecialParamsFromUrl';
import { mutator } from 'satcheljs';

mutator(updateSharingLinkFromSharingDialog, actionMessage => {
    const sharingLink: SharingLinkInfo = getSharingLinkInfo(actionMessage.linkId);

    const specialParams: string = getSharingLinkSpecialParamsFromUrl(sharingLink.url);

    sharingLink.url = actionMessage.sharingDialogResponse.url;

    if (specialParams != null) {
        sharingLink.url += (sharingLink.url.indexOf('?') === -1 ? '?' : '&') + specialParams;
    }
});

mutator(updateSharingLinkUrl, actionMessage => {
    const sharingLink: SharingLinkInfo = getSharingLinkInfo(actionMessage.linkId);

    sharingLink.url = actionMessage.newLinkUrl;
});
